import { SwapKitApi } from "@swapkit/api";
import { AxiosError } from "axios";

import { invariant } from "@coinbot/forge-api/helpers";

import { ForgeThorname } from "../../models";
import { THORNAME_REGEXP_INVALID_CHAR } from "../shared";

export const getTHORNameByName = async (tns: string): Promise<ForgeThorname | undefined> => {
  try {
    invariant(tns && typeof tns === "string", "TNS is required");

    const tnsDetails = await SwapKitApi.getTHORNameDetails(normalizeTnsName(tns));

    // const { data: tnsDetails } = await midgard.get<ForgeThorname>(
    //   `thorname/lookup/${normalizeTnsName(tns)}`,
    // );

    return { ...tnsDetails, tns } as ForgeThorname;
  } catch (err) {
    if (err instanceof AxiosError) {
      if (err?.response?.status === 404) return;
    }

    console.error("error getTHORNameByName", err);
    return;
  }
};

export const normalizeTnsName = (tnsName: string) => {
  const sliced = tnsName?.trim()?.toLowerCase()?.slice(0, 30);

  // FIXME: add support for emojis in the future! Currently unsupported by the protocol
  return sliced?.replace(THORNAME_REGEXP_INVALID_CHAR, "");
};
